import copy from 'copy-to-clipboard';
import dayjs from 'dayjs';
import extractTextFromJSX from 'utils/extractTextFromJsx';
import { cleanFileName } from 'utils/oneLiners';

export default function exportTableToCsv(finalColumns, sortedData, target = 'csv', exportPrefix = 'table-data') {
  const exportableColumns = finalColumns
      .filter(c => c.exportable !== false);

  let separator = '\t';
  switch (target) {
      case 'clipboard':
          separator = '\t';
          break;
      case 'csv':
          separator = ';';
          break;
      default:
          alert('Invalid target: ' + target);
          return;
  }

  // Escape CSV field: wrap in quotes, escape internal " as "", and normalize newlines to space
  // so one data row = one line in file (avoids empty rows in Google Sheets / Excel).
  const escapeCsvField = (raw) => {
    const s = (raw !== null && raw !== undefined) ? ('' + raw) : '';
    const escaped = s.replace(/"/g, '""').replace(/[\r\n]+/g, ' ');
    return `"${escaped}"`;
  };

  const header = exportableColumns.map(col => escapeCsvField(extractTextFromJSX(col.title))).join(separator);
  const body = sortedData.map(row =>
      exportableColumns.map(col => {
          const getColValue = (row, col) => {
              if (col.exportValue) {
                  return col.exportValue(row);
              } else if (col.render) {
                  if (col.dataIndex) {
                      return extractTextFromJSX(col.render(row[col.dataIndex], row));
                  } else {
                      return extractTextFromJSX(col.render(row));
                  }
              } else {
                  return row[col.dataIndex];
              }
          }
          const value = getColValue(row, col);
          const eq = col.exportExactCsv ? '=' : '';

          // Note: This is a possible auto-detect instead of exportExactCsv -- currently not in use
          //   const eq = (col.exportExactCsv || value?.substr(0, 1) == '+') ? '=' : '';

          return `${eq}${escapeCsvField(value)}`;
      }
      )
      .join(separator)
  ).join('\n');

  const csv = `${header}\n${body}`;

  switch (target) {
      case 'clipboard':
          copy(csv, { format: 'text/plain' });
          break;
      case 'csv':
          const UTF8_BOM = '\uFEFF';
          const blob = new Blob([UTF8_BOM + csv], { type: 'text/csv;charset=utf-8;' });
          const link = document.createElement('a');
          link.href = URL.createObjectURL(blob);
          link.download = `${cleanFileName(exportPrefix)}-${dayjs().format('YYYYMMDD-HHMMss')}.csv`;
          link.click();
          URL.revokeObjectURL(link.href);
          break;
  }
};
